import React, { useEffect, useState } from "react";
import axios from "axios";
import { useApp, API } from "@/contexts/AppContext";
import { Building2, Users, MessageSquare, Activity, CheckCircle2, Clock } from "lucide-react";

export default function SuperHome() {
  const { t } = useApp();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/stats`).then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const cards = [
    { label: t.super.total_hospitals, value: stats?.hospitals?.total ?? "—", icon: Building2, color: "#1E4631", testid: "stat-hospitals" },
    { label: t.super.active_hospitals, value: stats?.hospitals?.active ?? "—", icon: CheckCircle2, color: "#2E7D32", testid: "stat-active" },
    { label: t.super.pending_hospitals, value: stats?.hospitals?.pending ?? "—", icon: Clock, color: "#E3A72F", testid: "stat-pending" },
    { label: t.dash.total_patients, value: stats?.patients?.total ?? "—", icon: Users, color: "#D96C4A", testid: "stat-patients" },
    { label: t.super.total_sms, value: stats?.sms_sent ?? "—", icon: MessageSquare, color: "#1E4631", testid: "stat-sms" },
    { label: t.dash.appts_today, value: stats?.appointments?.today ?? "—", icon: Activity, color: "#5C6B61", testid: "stat-appts" },
  ];

  return (
    <div className="space-y-8" data-testid="super-home">
      <div>
        <h1 className="text-3xl font-[Outfit] font-bold">{t.super.home}</h1>
        <p className="text-[#5C6B61] mt-1">Vue agrégée de tous les hôpitaux de la plateforme KWIKILA Care.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {cards.map((c, i) => (
          <div key={i} data-testid={c.testid} className="bg-white rounded-2xl border border-[#E5EBE7] p-6 hover:shadow-md transition">
            <div className="w-11 h-11 rounded-xl grid place-items-center" style={{ background: `${c.color}15`, color: c.color }}>
              <c.icon className="w-5 h-5"/>
            </div>
            <div className="mt-4 text-3xl font-[Outfit] font-bold">{c.value}</div>
            <div className="mt-1 text-sm text-[#5C6B61]">{c.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
